import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Text", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "resources" }, "Resources", -1)
const _hoisted_8 = { class: "form-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.scenario)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.scenarioId)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Edit Scenario"))
          : (_openBlock(), _createElementBlock("h1", _hoisted_3, "Add Scenario")),
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Textarea, {
              id: "text",
              type: "text",
              modelValue: _ctx.scenario.text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenario.text) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Editor, {
              id: "resources",
              modelValue: _ctx.scenario.resources,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scenario.resources) = $event)),
              editorStyle: "height: 320px",
              formats: ['link']
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: _ctx.scenarioId ? 'Save Scenario' : 'Add Scenario',
              type: "submit"
            }, null, 8, ["label"]),
            (_ctx.scenarioId)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-danger",
                  onClick: _ctx.deleteScenario
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}